import { useContext } from "react";
import Box from "@mui/material/Box";
import EventStartDate from "../EventStartDate/EventStartDate";
import EventStartTime from "../EventStartTime/EventStartTime";
import EventLocation from "../EventLocation/EventLocation";
import { StoreContext } from "../../store/Store";

const EventTopCoordinates = () => {
  const [state,] = useContext(StoreContext);
  return (
    <Box display="flex" flexGrow="1" height="60px" alignItems="center">
      {state.selectedEvent && (
        <>
          <Box ml={7}>
            <EventStartDate dateTime={state.selectedEvent.startDateTime} />
          </Box>
          <Box ml={7}>
            <EventStartTime
              dateTime={state.selectedEvent.startDateTime}
              timeZone={state.selectedEvent.timeZone}
            />
          </Box>
          <Box ml={7}>
            <EventLocation name={state.selectedEvent.locationName} />
          </Box>
        </>
      )}
    </Box>
  );
};

export default EventTopCoordinates;
